/**
 * Clase que instancia nuestro objeto por default para hacer peticiones en la pagina de PFD Tostacion
 */
export class PFDFetching {
  constructor(
    idSeccion,
    secuencia,
    ultimo = 0,
    frecuencia = 5,
    dias = 7,
    orden = 0
  ) {
    this.idSeccion = idSeccion;
    this.secuencia = secuencia;
    this.ultimo = ultimo;
    this.frecuencia = frecuencia;
    this.dias = dias;
    this.orden = orden;
  }

  setIdSeccion(idSeccion) {
    this.idSeccion = idSeccion;
    return this;
  }

  setSecuencia(secuencia) {
    this.secuencia = secuencia;
    return this;
  }

  setUltimo(ultimo) {
    this.ultimo = ultimo;
    return this;
  }

  setFrecuencia(frecuencia) {
    this.frecuencia = frecuencia;
    return this;
  }

  setDias(dias) {
    this.dias = dias;
    return this;
  }

  setOrden(orden) {
    this.orden = orden;
    return this;
  }
}
